/**
 * When a proposal comment becomes visible to its audience.
 *
 * A comment used to be staged: posting it stored an author-only draft, and it reached the audience
 * only when the author saved (or published the row by hand). That made every comment a two-step act
 * and gave the save and submit dialogs a second subject — which comments to send — on top of the
 * changes they were already about.
 *
 * A proposal now posts its comments: writing one publishes and broadcasts it to the audience the
 * author picked, with no pending state in between. Every other comment action followed it — an edit, a
 * retraction, a publication, a deletion and a re-aim each take effect when their author performs them,
 * on that comment's own row — so nothing about the conversation waits for, or appears in, a proposal
 * save.
 *
 * This is intended to become a per-proposal setting, so the drafting path it replaces is deliberately
 * still here and still reachable: `saveDraftComment` stores an author-only draft, and the row's own
 * Publish button delivers it. Flipping this constant to `false` restores drafting wholesale — posting
 * stores a draft, the author publishes it when they mean to, and every action on it is still immediate.
 * What drafting no longer has is a bulk "publish everything I am holding" step hanging off the proposal
 * save; a draft is delivered by its author saying so about that comment. A setting will replace this
 * constant, not the paths it chooses between.
 */
export const proposalCommentsPublishOnPost = true;

/** What the composer's post button is called, given when the comment becomes visible. */
export const proposalCommentPostButtonLabel = proposalCommentsPublishOnPost ? "Post" : "Draft";
